import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container, Editor } from 'react-mobiledoc-editor'
import MobiledocKit from 'mobiledoc-kit'
import MobiledocDOMRenderer from 'mobiledoc-dom-renderer'
import 'mobiledoc-kit/dist/css/mobiledoc-kit.css'
import Toolbar from '../editor/Toolbar'
import BlockMenu from '../editor/BlockMenu'
import { Image, Divider } from '../editor/cards'

/*
 * This is a stopgap to parse <img /> tags BACK into Image cards
 * in order to work with Fridge's way of only dealing with html strings
 * as rich text.
 *
 * In the future, only mobiledoc will be stored, and the API will be able
 * to return the particular formats.
 */
const imageToCard = (node, builder, {addSection, nodeFinished}) => {
  if (node.nodeType !== 1 || node.tagName !== 'IMG') return

  const payload = {src: node.src}
  const cardSection = builder.createCardSection('Image', payload)
  addSection(cardSection)
  nodeFinished()
}

const config = {
  cards: [Image, Divider],
  placeholder: 'Click to get started ...',
  autofocus: false,
  spellcheck: true,
  parserPlugins: [imageToCard]
}

const BLANK_DOC = {
  version: '0.3.0',
  markups: [],
  atoms: [],
  cards: [],
  sections: [[1, 'p', [[0, [], 0, '']]]]
}

export default class RichTextEditor extends Component {
  static propTypes = {
    id: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func
  }

  state = {
    mobiledoc: null,
    html: ''
  }

  onChange = value => {
    // render to html
    const renderer = new MobiledocDOMRenderer.default({cards: config.cards})
    const {result} = renderer.render(value)
    const div = document.createElement('div')
    div.appendChild(result.cloneNode(true))
    const html = div.innerHTML

    // const html = this.container.editor.serializeTo('html')
    this.setState({value, html}, () => {
      this.props.onChange && this.props.onChange(html)
    })
  }

  componentDidMount () {
    this.componentWillReceiveProps(this.props)
    // mobiledoc needs to start with at least 1 empty section to trigger the "+" menu.
    // See: https://github.com/bustle/mobiledoc-kit/issues/443
    if (!this.props.value) {
      this.setState({mobiledoc: BLANK_DOC})
    }
  }

  componentWillReceiveProps (nextProps) {
    const value = nextProps.value || ''
    if (value !== this.state.html) {
      if (typeof nextProps.value === 'string') {
        this.setEditorHtml(nextProps.value)
      } else {
        this.setState({mobiledoc: nextProps.value})
      }
    }
  }

  setEditorHtml (html) {
    const editor = new MobiledocKit.Editor({...config, html})
    const mobiledoc = editor.serialize()
    this.setState({mobiledoc: null}, () => {
      this.setState({mobiledoc, html})
    })
  }

  render () {
    const {mobiledoc} = this.state

    return <div className='content-editor rich'>
      {mobiledoc &&
        <Container
          {...config}
          className='content-pane'
          onChange={this.onChange}
          didCreateEditor={this.editorDidMount}
          mobiledoc={mobiledoc}
        >
          <Editor />
          <Toolbar />
          <BlockMenu />
        </Container>
      }
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/RichTextEditor.js